// contexts/DrawerContext.js
import React, { createContext, useContext, useState } from 'react';

const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState(null);

  const openDrawer = () => setIsDrawerOpen(true);
  const toggleDrawer = () => setIsDrawerOpen(prev => !prev);
  const setContent = (content = null) => setDrawerContent(content);
  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setDrawerContent(null);
  };

  return (
    <DrawerContext.Provider value={{
      isDrawerOpen,
      drawerContent,
      setContent,
      openDrawer,
      closeDrawer,
      toggleDrawer
    }}>
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};